import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { History as HistoryIcon, Search } from "lucide-react";

const ACTION_COLOR = {
  create: "bg-secondary/15 text-secondary",
  update: "bg-accent/20 text-accent-foreground",
  delete: "bg-destructive/15 text-destructive",
  login: "bg-primary/10 text-primary",
  upload: "bg-accent/15 text-accent-foreground",
};

const AdminAudit = () => {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/audit?limit=500").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const filtered = items.filter((it) => {
    if (!q) return true;
    const blob = `${it.user_email} ${it.action} ${it.resource_type} ${it.resource_id || ""}`.toLowerCase();
    return blob.includes(q.toLowerCase());
  });

  return (
    <div data-testid="admin-audit-page">
      <div className="flex items-end justify-between gap-4 mb-8">
        <div>
          <h1 className="font-heading text-3xl font-semibold tracking-tight">Audit Log</h1>
          <p className="text-muted-foreground mt-1 flex items-center gap-2">
            <HistoryIcon size={14} /> Every admin action recorded — sorted newest first.
          </p>
        </div>
        <div className="relative w-64">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" size={14} />
          <Input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Filter by user, action, type..."
            className="pl-9"
            data-testid="admin-audit-search"
          />
        </div>
      </div>

      <Card className="border-border">
        <CardContent className="p-0">
          <table className="w-full text-sm">
            <thead className="bg-muted/40">
              <tr>
                <th className="text-left px-5 py-3 font-medium">When</th>
                <th className="text-left px-5 py-3 font-medium">User</th>
                <th className="text-left px-5 py-3 font-medium">Action</th>
                <th className="text-left px-5 py-3 font-medium">Resource</th>
                <th className="text-left px-5 py-3 font-medium">IP</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 && (
                <tr><td colSpan={5} className="px-5 py-10 text-center text-muted-foreground">No audit entries.</td></tr>
              )}
              {filtered.map((it) => (
                <tr key={it.id} className="border-t border-border align-top" data-testid={`audit-row-${it.id}`}>
                  <td className="px-5 py-3 whitespace-nowrap text-muted-foreground">
                    {new Date(it.created_at).toLocaleString()}
                  </td>
                  <td className="px-5 py-3">
                    <div className="font-medium">{it.user_email}</div>
                    <div className="text-[11px] uppercase tracking-wider text-muted-foreground">{it.user_role}</div>
                  </td>
                  <td className="px-5 py-3">
                    <span className={`inline-block px-2 py-0.5 text-[11px] uppercase tracking-wider rounded-full ${ACTION_COLOR[it.action] || "bg-muted text-foreground"}`}>
                      {it.action}
                    </span>
                  </td>
                  <td className="px-5 py-3">
                    <div>{it.resource_type}</div>
                    {it.resource_id && <div className="text-[11px] text-muted-foreground font-mono">{it.resource_id.slice(0, 8)}</div>}
                  </td>
                  <td className="px-5 py-3 text-muted-foreground text-xs">{it.ip || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminAudit;
